export const PRODUCTS_PER_PAGE = 9;

export const SINGLE_ITEMS = {
  NEW: 'New',
  BESTSELLERS: 'Best sellers',
};

export const RATING_ITEMS = {
  DESC: 'High to low Rating',
  ASC: 'Low to high Rating',
  FIVE: '★ ★ ★ ★ ★',
  FOUR: '★ ★ ★ ★',
  THREE: '★ ★ ★',
  TWO: '★ ★',
  ONE: '★',
};

export const PRICE_ITEMS = {
  DESC: 'High to low Price',
  ASC: 'Low to high Price',
  PRICE25: '$25 - $40',
  PRICE40: '$40 - $70',
  PRICE70: '$70 - $100',
  PRICE100: '$100+',
};

export const SALE_ITEMS = {
  DESC: 'High to low Sale',
  ASC: 'Low to high Sale',
  SALE30: '30% - 20%',
  SALE15: '15% - 5%',
};
